import React from 'react';
const scrollToPricing = () => {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function BonusSection() {
  const bonuses = [{
    num: 1,
    title: 'Kit de Organización Familiar',
    desc: 'Plantillas para ordenar responsabilidades, tareas y decisiones',
    value: 12,
    color: 'yellow'
  }, {
    num: 2,
    title: 'Protocolos de Crisis',
    desc: 'Qué hacer en situaciones difíciles paso a paso',
    value: 14,
    color: 'orange'
  }, {
    num: 3,
    title: 'Plan 7 Días "Modo Claridad"',
    desc: 'Un sistema para empezar a ordenar todo rápidamente',
    value: 15,
    color: 'red'
  }, {
    num: 4,
    title: 'Guía de Conversaciones Difíciles',
    desc: 'Scripts reales para hablar sin conflicto',
    value: 12,
    color: 'blue'
  }, {
    num: 5,
    title: 'Checklist de Señales de Alerta',
    desc: 'Detecta cuándo actuar y cuándo observar',
    value: 9,
    color: 'purple'
  }, {
    num: 6,
    title: 'Rutinas de Cuidado Sostenible',
    desc: 'Evita el agotamiento y cuida tu energía',
    value: 10,
    color: 'teal'
  }];
  const colorMap: Record<string, {
    bg: string;
    border: string;
    text: string;
  }> = {
    yellow: {
      bg: 'bg-yellow-400/10',
      border: 'border-yellow-400/20',
      text: 'text-yellow-500'
    },
    orange: {
      bg: 'bg-orange-400/10',
      border: 'border-orange-400/20',
      text: 'text-orange-500'
    },
    red: {
      bg: 'bg-red-400/10',
      border: 'border-red-400/20',
      text: 'text-red-500'
    },
    blue: {
      bg: 'bg-blue-400/10',
      border: 'border-blue-400/20',
      text: 'text-blue-500'
    },
    purple: {
      bg: 'bg-purple-400/10',
      border: 'border-purple-400/20',
      text: 'text-purple-500'
    },
    teal: {
      bg: 'bg-teal-400/10',
      border: 'border-teal-400/20',
      text: 'text-teal-500'
    }
  };
  return <section className="w-full bg-[#111111] py-8 md:py-12 px-4 border-t border-gray-800" data-id="element-15">
      <div className="max-w-3xl mx-auto" data-id="element-16">
        <div className="text-center mb-6" data-id="element-17">
          <h2 className="text-2xl md:text-3xl font-black font-heading text-white mb-2" data-id="element-18">
            🎁 MÁS LOS 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-sm md:text-base text-yellow-400 font-bold font-body" data-id="element-19">
            Gratis solo por HOY
          </p>
        </div>

        <div className="space-y-3" data-id="element-20">
          {bonuses.map(bonus => {
          const c = colorMap[bonus.color];
          return <div key={bonus.num} className="bg-gray-900 rounded-xl p-4 border border-yellow-500/40 shadow-[0_0_10px_rgba(250,204,21,0.08)] relative overflow-hidden" data-id="element-21">
                <div className="absolute top-0 right-0 bg-red-600 text-white text-[9px] md:text-[10px] font-bold px-3 py-1 rounded-bl-lg" data-id="element-22">
                  🎁 GRATIS
                </div>
                <div className="flex items-start gap-3" data-id="element-23">
                  <div className={`${c.bg} border ${c.border} rounded-lg p-2 flex-shrink-0`} data-id="element-24">
                    <span className="text-xl" data-id="element-25">🎁</span>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-26">
                    <p className={`text-[10px] font-bold ${c.text} mb-0.5 font-heading tracking-widest uppercase`} data-id="element-27">
                      BONO {bonus.num}
                    </p>
                    <h3 className="text-base md:text-lg font-black font-heading text-white mb-1 leading-tight" data-id="element-28">
                      {bonus.title}
                    </h3>
                    <p className="text-gray-400 font-body text-xs md:text-sm leading-snug mb-2" data-id="element-29">
                      {bonus.desc}
                    </p>
                    <div className="flex items-center gap-2 text-xs" data-id="element-30">
                      <span className="text-gray-500 line-through" data-id="element-31">
                        USD {bonus.value}
                      </span>
                      <span className="text-green-400 font-bold" data-id="element-32">GRATIS</span>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="bg-gradient-to-r from-yellow-500 to-yellow-400 rounded-xl p-4 text-center mt-6 cursor-pointer shadow-lg hover:scale-[1.02] transition-transform duration-300" onClick={scrollToPricing} data-id="element-33">
          <p className="text-base md:text-lg font-black font-heading text-gray-900" data-id="element-34">
            🎁 Valor total bonos:{' '}
            <span className="line-through opacity-70" data-id="element-35">USD 72</span> →{' '}
            <span className="text-red-700 text-xl" data-id="element-36">GRATIS</span>
          </p>
        </div>
      </div>
    </section>;
}